module.exports = __webpack_public_path__ + "html/recover.7c05df.html";


/*****************
 ** WEBPACK FOOTER
 ** ../AccountApp/recover.html
 ** module id = 704
 ** module chunks = 1
 **/